import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Gallery.css";

export default function ResponsiveSlider({ images = [] }) {
  const defaultImages = [
    "/yoga1.jpeg",
    "/yoga02.jpeg",
    "/yoga03.jpeg",
    "/yoga04.jpeg",
    "/yoga05.jpeg",
    "/yoga06.jpeg",
    "/yoga07.jpeg",
    "/yoga08.jpeg",
    "/yoga09.jpeg",
    "/yoga10.jpeg",
    "/yoga11.jpeg",
    "/yoga12.jpeg",
    "/yoga13.jpeg",
    "/yoga14.jpeg",
    "/yoga15.jpeg",
    "/yoga16.jpeg",
    "/ajay.jpeg",
  ];

  const slides = images.length ? images : defaultImages;

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <div className="gallery-slider-wrapper">
      <Slider {...settings}>
        {slides.map((src, idx) => (
          <div key={idx} className="gallery-slide">
            <motion.div
              className="gallery-image-wrapper"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ delay: (idx % 4) * 0.04 }}
            >
              <img
                src={src}
                alt={`Gallery image ${idx + 1}`}
                className="gallery-image"
                loading="lazy"
                draggable="false"
              />
            </motion.div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
